var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.675,
    height: 11.882,
    viewBox: "0 0 9.675 11.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play",
    d: "M11.662,3.946,6.938.48A2.476,2.476,0,0,0,3,2.477V9.408a2.476,2.476,0,0,0,3.94,2l4.723-3.466a2.476,2.476,0,0,0,0-3.993ZM11.075,7.14,6.352,10.606a1.485,1.485,0,0,1-2.362-1.2V2.477A1.46,1.46,0,0,1,4.8,1.154,1.494,1.494,0,0,1,5.479.991a1.471,1.471,0,0,1,.873.292l4.723,3.466a1.485,1.485,0,0,1,0,2.394Z",
    fill: "#35C385",
    transform: "translate(-3 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartProduct);
export default __webpack_public_path__ + "static/media/startProduct.a488b3af500928bd6eb3c04b8c6dcf13.svg";
export { ForwardRef as ReactComponent };